import getLocale from './get-locale';

export default {
  getLocale,
};
